import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Import from project
import "../../Style/dialogstyle.scss";
import {
  CREATE_MEETING_TYPE,
  UPDATE_MEETING_TYPE,
} from "../../Schema/MeetingType";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component";

export default function MeetingTypeForm({
  open,
  editData, 
  setRefetch,
  handleClose,
  dialogTitle,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createMeetingType] = useMutation(CREATE_MEETING_TYPE, {
    onCompleted: ({ createMeetingType }) => {
      setLoading(false);
      if (createMeetingType?.isSuccess === true) {
        setAlert(true, "success", createMeetingType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createMeetingType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateMeetingType] = useMutation(UPDATE_MEETING_TYPE, {
    onCompleted: ({ updateMeetingType }) => {
      setLoading(false);
      if (updateMeetingType?.isSuccess === true) {
        setAlert(true, "success", updateMeetingType?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateMeetingType?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    title: Yup.string().required(t("required")),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      remark: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createMeetingType({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        updateMeetingType({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("title", editData?.title);
      setFieldValue("remark", editData?.remark);
    }
  }, [editData, open]);

  return (
    <Dialog open={open} className="dialog-container" maxWidth="xs" fullWidth>
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_meetingtype")
            : t("modal_title_update_meetingtype")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_title")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_title")}
                  {...getFieldProps("title")}
                  error={Boolean(touched.title && errors.title)}
                  helperText={touched.title && errors.title}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_remark")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_remark")}
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? t("create") : t("update")} 
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
